import { Component } from '@theme/component';

/**
 * Mobile menu drawer toggle for the custom header.
 * Opens a full-screen <dialog> with the Shopify menu; closes via the X button,
 * ESC (native) or clicking the backdrop.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog
 * @extends Component<Refs>
 */
class HeaderCustomMenu extends Component {
  requiredRefs = ['dialog'];

  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog.addEventListener('click', this.#onBackdrop);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.dialog?.removeEventListener('click', this.#onBackdrop);
  }

  // bound via on:click="open" no botão hambúrguer
  open = () => {
    this.refs.dialog?.showModal?.();
  };

  // bound via on:click="close" no botão X
  close = () => {
    this.refs.dialog?.close?.();
  };

  #onBackdrop = (event) => {
    if (event.target === this.refs.dialog) this.refs.dialog.close();
  };
}

if (!customElements.get('header-custom-menu')) {
  customElements.define('header-custom-menu', HeaderCustomMenu);
}
